﻿import Emitter from 'events';

import { CHANGE_STATE } from '~/Scripts/Handlers/StateHandler';

export const MENU_OPEN = 'menu_open'; 

// --------------------------------------------------------------
// Components
// --------------------------------------------------------------

export default class Menu extends Emitter {
  menuModalSelector = "[data-menu]";
  menuAccordionSelector = "[data-accordion]";
  menuAccordionTriggerClass = "menu__accordion--trigger";
  expandedClass = "expanded";
  menuListClass = "menu__list--phases";
  menuListItemClass = "menu__list__item";

  firstFocusableElement = null;
  lastFocusableElement = null;

  constructor() {
    super();
    this.eventListener();
    this.on(CHANGE_STATE, this._stateUpdated);
    this.handleViewPort();
  }

  eventListener = () => {
    window.addEventListener("resize", () => {
      this.handleViewPort();
    });

    const menuTriggers = document.querySelectorAll("[data-accordion-toggle]");
    menuTriggers.forEach((trigger) => {
      const group = trigger.getAttribute("data-group");
      trigger.addEventListener("click", (event) => {this.toggleMenuGroup(group, event)});
    });
  }

  handleViewPort = () => {
    const width = window.innerWidth;
    const isMobile = width < 981;
    const accordions = document.querySelectorAll(this.menuAccordionSelector);

    if (isMobile) {
      accordions.forEach((accordion) => this.closeSubmenu(accordion));
    } else {
      accordions.forEach((accordion) => this.openSubmenu(accordion));
    }
  }

    /**
   * Open the menu
   */
    open = () => {
      const menu = document.querySelector(this.menuModalSelector);

      if (menu && !menu.classList.contains("menu--expanded")) {
        menu.classList.add("menu--expanded");
        this.enableTrapFocus();
  
        document.body.classList.add("has-overlay");
      }
    }

      /**
   * Close the menu
   */
  close = () => {

    const menu = document.querySelector(this.menuModalSelector);

      if (menu && menu.classList.contains("menu--expanded")) {
        menu.classList.remove("menu--expanded");
        this.disableTrapFocus();
  
        document.body.classList.remove("has-overlay");
      }
  }
  
    toggleMenuGroup = (group, event) => {
      const trigger = document.querySelector(
        "." + this.menuAccordionTriggerClass + "-" + group
      );
      const parent = trigger.closest(this.menuAccordionSelector);
      const currentList = parent.querySelector("." + this.menuListClass);
      const accordions = document.querySelectorAll(this.menuAccordionSelector);
      const shouldOpen = !currentList.classList.contains(this.expandedClass);
  
      accordions.forEach((accordion) => {
        this.closeSubmenu(accordion);
      });
  
      if (shouldOpen) {
        this.openSubmenu(parent);
      }
    }
    
  
    // trap focus in modal
    enableTrapFocus = () => {
      const focusableElements = "button, a";
      const modal = document.querySelector(this.menuModalSelector); // select the modal by class
      const focusableContent = modal.querySelectorAll(focusableElements);
  
      this.firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
      this.lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  
      document.addEventListener("keydown", this.keyDownListener);
    };
  

    /**
     * Accordion is each submenu
     */
    openSubmenu = (accordion) => {
      const currentList = accordion.querySelector("." + this.menuListClass);
      const trigger = accordion.querySelector(
        "." + this.menuAccordionTriggerClass
      );
  
      if (currentList) {
        currentList.classList.add(this.expandedClass);
        accordion.classList.add(this.expandedClass);
  
        const currentListItems = currentList.querySelectorAll(
          `.${this.menuListItemClass} a`
        );
  
        if (currentListItems) {
          currentListItems.forEach((item) => {
            item.removeAttribute("tabIndex", "-1");
          });
        }
      }
  
      if (trigger) {
        trigger.setAttribute("aria-expanded", true);
      }
    };
  
    /**
     * Accordion is each submenu
     */
    closeSubmenu = (accordion) => {
      const currentList = accordion.querySelector("." + this.menuListClass);
      const trigger = accordion.querySelector(
        "." + this.menuAccordionTriggerClass
      );
  
      if (currentList) {
        currentList.classList.remove(this.expandedClass);
        accordion.classList.remove(this.expandedClass);
  
        const currentListItems = currentList.querySelectorAll(
          `.${this.menuListItemClass} a`
        );
  
        if (currentListItems) {
          currentListItems.forEach((item) => {
            item.setAttribute("tabIndex", "-1");
          });
        }
      }
  
      if (trigger) {
        trigger.setAttribute("aria-expanded", false);
      }
    };
  
    keyDownListener(e) {;
      let isTabPressed = e.key === "Tab" || e.keyCode === 9;
  
      if (!isTabPressed) {
        return;
      }
  
      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === this.firstFocusableElement) {
          this.lastFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === this.lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          this.firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    };
  
  
    disableTrapFocus() {
      document.removeEventListener("keydown", this.keyDownListener);
    };
  
  
    /**
     * Handle state update.
     *
     * @param {Object} next Next state
     * @param {Object} previous Previous state
     */
    _stateUpdated = (next, previous) => {
      if (!previous[MENU_OPEN] && next[MENU_OPEN]) {
        this.open();
      } else if (previous[MENU_OPEN] && !next[MENU_OPEN]) {
        this.close();
      }
    }
  }

